/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Created_AtInputs */

const en_admin_categories_created_at = /** @type {(inputs: Admin_Categories_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created At`)
};

const zh_admin_categories_created_at = /** @type {(inputs: Admin_Categories_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建时间`)
};

/**
* | output |
* | --- |
* | "Created At" |
*
* @param {Admin_Categories_Created_AtInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_created_at = /** @type {((inputs?: Admin_Categories_Created_AtInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Created_AtInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_created_at(inputs)
	return zh_admin_categories_created_at(inputs)
});
export { admin_categories_created_at as "admin.categories.created_at" }